import { useState } from "react";
import { IGroupMessageView } from "../../../../App/Typings/MessageText";
import { useDeleteScheduledMessage } from "../../../../App/Queries/MessageQueries";
import { useDebouncedHandler } from "../../../../App/State/Hooks/useDebouncedHandler";

export default function ScheduleTextMessageState() {
  const defaultMsg: IGroupMessageView = {
    create: new Date(),
    messageDisplay: "", //
    messageTextId: "",
    messageTrackingId: "",
    scheduledTimeEaster: "",
    userName: "",
    type: "",
    messageState: "",
    userId: "",
    recipient: "",
    recipientId: "",
  };
  const [scheduledMessages, setScheduledMessages] = useState<IGroupMessageView[]>([]);
  const [actionMessage, setActionMessage] = useState<IGroupMessageView>(defaultMsg);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const { mutate: deleteScheduledMessage } = useDeleteScheduledMessage();

  const handleConfirmDeleteSelectedScheduledMessages = useDebouncedHandler((msg: IGroupMessageView) => {
    const filterList = scheduledMessages.filter((list) => {
      return msg !== list;
    });

    deleteScheduledMessage(msg.messageTrackingId, {
      onSuccess: () => {
        setScheduledMessages(filterList);
      },
    });
  }, 300);

  const handleConfirmationResponse = (msg: IGroupMessageView, response: boolean) => {
    if (response) {
      const filterList = scheduledMessages.filter((list) => {
        return msg !== list;
      });
      setScheduledMessages(filterList);
      handleConfirmDeleteSelectedScheduledMessages(msg);
    }
    setShowConfirmDialog(false);
  };

  return {
    getters: {
      showConfirmDialog,
      actionMessage,
    },
    setters: {
      setActionMessage,
    },
    handlers: {
      handleConfirmationResponse,
    },
  };
}
